export default {
  GridTree: 500,
};
